"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return Math.floor(Date.now() / 1000);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/date/nowAsEpoch.js
// module id = 286
// module chunks = 0